<template>
  <v-form ref="form">
    <v-row no-gutters>
      <v-col cols="12" md="1">
        <v-text-field
          v-model="form.zip"
          :error-messages="$page.errors.zip"
          label="PLZ"
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.city"
          :error-messages="$page.errors.city"
          label="Ort"
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12" md="4" offset-md="1">
        <v-text-field
          v-model="form.street"
          :error-messages="$page.errors.street"
          label="Straße"
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="form.house_number"
          :error-messages="$page.errors.house_number"
          label="Hausnummer"
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12">
        <v-checkbox
          v-model="contact_person_show"
          label="Ansprechpartner abweichend"
          :value="true"
        />
      </v-col>
    </v-row>
    <v-row v-show="contact_person_show" no-gutters>
      <v-col cols="12" md="1">
        <v-select
          v-model="form.contact_person.form_of_address"
          :error-messages="
            $page.errors.contact_person
              ? $page.errors.contact_person.form_of_address
              : null
          "
          :items="['Herr', 'Frau']"
          label="Anrede"
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="form.contact_person.first_name"
          :error-messages="
            $page.errors.contact_person
              ? $page.errors.contact_person.first_name
              : null
          "
          label="Vorname"
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="form.contact_person.last_name"
          :error-messages="
            $page.errors.contact_person
              ? $page.errors.contact_person.last_name
              : null
          "
          label="Nachname"
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12" md="3" offset-md="1">
        <v-text-field
          v-model="form.contact_person.telephone"
          :error-messages="
            $page.errors.contact_person
              ? $page.errors.contact_person.telephone
              : null
          "
          label="Tel"
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="form.contact_person.eMail"
          :error-messages="
            $page.errors.contact_person
              ? $page.errors.contact_person.email
              : null
          "
          label="E-Mail"
          outlined
          hide-details="auto"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
   name: 'StandortForm',

   props: {
      form: {
         type: Object,
         required: true,
      },
   },

   data: (vm) => ({
      contact_person_show: false,
   }),
}
</script>
